'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css2 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _css3 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 创建/编辑客户等级按钮及表单
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../constants');

var _modal_form = require('./modal_form');

var _modal_form2 = _interopRequireDefault(_modal_form);

var _currency_input = require('./currency_input');

var _currency_input2 = _interopRequireDefault(_currency_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var LevelForm = _react2.default.createClass({
    displayName: 'LevelForm',
    onOk: function onOk(form) {
        return _axios2.default.post(_constants.API_LEVELS, form.getFieldsValue()).then(function (response) {
            _message2.default.info('操作成功', 1.5);
        }).catch(function (error) {
            _message2.default.error('\u64CD\u4F5C\u5931\u8D25\uFF1A' + error.data, 2);
        });
    },
    render: function render() {
        var _props = this.props,
            _props$level = _props.level,
            level = _props$level === undefined ? {} : _props$level,
            form = _props.form,
            style = _props.style,
            _props$title = _props.title,
            title = _props$title === undefined ? '创建客户等级' : _props$title,
            _props$btnText = _props.btnText,
            btnText = _props$btnText === undefined ? title : _props$btnText;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        return _react2.default.createElement(
            _modal_form2.default,
            { style: style, form: form, type: 'primary', onOk: this.onOk.bind(this, form), title: title, btnText: btnText },
            _react2.default.createElement(
                _form2.default,
                null,
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { required: true, label: '\u7B49\u7EA7\u540D\u79F0' }),
                    getFieldDecorator('key', {
                        rules: [{ required: true, message: '请输入等级名称!' }],
                        initialValue: level.key
                    })(_react2.default.createElement(_input2.default, { type: 'text' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u7B49\u7EA7\u6298\u6263' }),
                    getFieldDecorator('discount', {
                        rules: [{ required: true, message: '请输入等级折扣!' }],
                        initialValue: level.discount
                    })(_react2.default.createElement(_currency_input2.default, { addonBefore: '', precision: 3 }))
                ),
                level.id ? _react2.default.createElement(
                    FormItem,
                    _extends({ className: 'hidden' }, formItemLayout, { label: '\u7B49\u7EA7\u7F16\u53F7' }),
                    getFieldDecorator('id', {
                        initialValue: level.id
                    })(_react2.default.createElement(_input2.default, null))
                ) : null
            )
        );
    }
});

exports.default = _form2.default.create()(LevelForm);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/level_form.js
// module id = 1334
// module chunks = 0